import {
  AdminInput,
  Button,
  CreateMenuCategoryV2Dto,
  Div,
  H5,
  Icon,
  Modal,
  PlusIcon,
  PropsModal,
  lightTheme,
} from '@vgrubs/components';
import {
  MenuAvailabilityV2Response,
  CategoryV2Response,
} from 'components/src/types/menu.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { AvailabilityComponent } from './AvailabilityComponent';

export const AddCategoryModal = ({
  addModal,
  closeModal,
  availability,
  setAvailability,
  setAddAvailabilityModal,
  handleAddCategory,
  handleEditCategory,
  edit,
}: PropsModal & {
  addModal: boolean | CategoryV2Response | null;
  availability: MenuAvailabilityV2Response[];
  setAvailability: Dispatch<SetStateAction<MenuAvailabilityV2Response[]>>;
  setAddAvailabilityModal: Dispatch<SetStateAction<boolean>>;
  handleAddCategory?: (
    name: CreateMenuCategoryV2Dto['name'],
    description: CreateMenuCategoryV2Dto['description'],
    availability: MenuAvailabilityV2Response[],
    emptyForm: () => void
  ) => void;
  handleEditCategory?: (
    name: CreateMenuCategoryV2Dto['name'],
    description: CreateMenuCategoryV2Dto['description'],
    availability: MenuAvailabilityV2Response[],
    emptyForm: () => void
  ) => void;
  edit?: boolean;
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const data = addModal;

  useEffect(() => {
    if (edit && typeof data === 'object') {
      setName(data?.name || '');
      setDescription(data?.description || '');
      setAvailability(data?.schedules || []);
    } else {
      emptyForm();
    }
  }, [data]);

  const emptyForm = () => {
    setName('');
    setDescription('');
    setAvailability([]);
  };

  const handleSubmit = () => {
    if (edit) {
      handleEditCategory?.(name, description, availability, emptyForm);
    } else {
      handleAddCategory?.(name, description, availability, emptyForm);
    }
  };

  return (
    <Modal
      isOpen={!!addModal}
      closeModal={closeModal}
      header={edit ? 'Edit Category' : 'Add Category'}
      logo={false}
      footer={
        <>
          <Button $selected $w="100%" onClick={handleSubmit}>
            Confirm
          </Button>
          <Button
            $mt="16"
            $selected
            $gray
            $w="100%"
            onClick={() => closeModal?.()}
          >
            Cancel
          </Button>
        </>
      }
      $numOfFloatingButtons={2}
    >
      <Div $flex $column $gap="24px">
        <AdminInput
          placeholder="Enter here"
          label="Category Name"
          value={name}
          onChange={({ target }: { target: HTMLInputElement }) =>
            setName(target.value)
          }
        />

        <AdminInput
          placeholder="Enter here"
          label="Description"
          type="textarea"
          value={description}
          onChange={({ target }: { target: HTMLTextAreaElement }) =>
            setDescription(target.value)
          }
        />

        {availability?.length > 0 ? (
          <>
            <Div $flex $alignCenter $between>
              <H5 $mb="0">Availability</H5>
              <Icon $pointer onClick={() => setAddAvailabilityModal(true)}>
                <PlusIcon />
              </Icon>
            </Div>

            <div>
              {availability.map((item, i) => (
                <AvailabilityComponent
                  item={item}
                  key={i}
                  index={i}
                  availability={availability}
                  setAvailability={setAvailability}
                />
              ))}
            </div>
          </>
        ) : (
          <Div
            $flex
            $center
            $gap="8px"
            $pointer
            onClick={() => setAddAvailabilityModal(true)}
          >
            <Icon>
              <PlusIcon />
            </Icon>

            <H5 $m="0" $color={lightTheme.primary}>
              Add Availability
            </H5>
          </Div>
        )}
      </Div>
    </Modal>
  );
};
